import { OptionTypeBase } from '@sprint/sprint-react-components';
import DataGridRequest from './DataGridRequest';
export class CustomPropertiesTypeRequest extends DataGridRequest<OptionTypeBase> {
    Url = 'custom_properties/types_api';
}
